import { List, fromJS } from 'immutable';
import * as actions from '../utils/Constants'

export default (state = getInitialState(), action) => {

    if (action.type === actions.ERROR) {
        console.error(action.payload.message);
        return state.push(fromJS(action.payload));
    }
    else {
        switch (action.type) {
            case actions.DISMISS_ALERT:
                {
                    return state.filterNot(x => x.get('traceId') === action.payload);
                }

            default:
                return state;
        }
    }
}

const getInitialState = () => {
    return List();
};